import view from './view.js';

export default view;



// WEBPACK FOOTER //
// ./src/login/index.js